import styled from 'styled-components';

import { colors } from 'global/colors';

const logoWidth = '166px';
export const maxWidth = 990;
const mediaMaxWidth = `max-width: ${maxWidth}px`;
const mediaMinWidth = `min-width: ${maxWidth}px`;

export const HeaderNav = styled.nav`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: flex-start;
  background: ${({ theme }) => theme.oldThemeHeader.background} !important;
  padding: 0px !important;
  height: 55px;
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  z-index: 999;
  @media (${mediaMaxWidth}) {
    justify-content: space-between;
  }
  @media print {
    display: none;
  }
`;

export const LogoImg = styled.img`
  width: ${logoWidth};
  cursor: pointer;
  padding-left: 12px;
`;

export const MenuIcon = styled.div`
  display: none;
  margin-right: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.oldThemeHeader.icon.color};
  :after {
    content: '\f0c9';
    font-family: FontAwesome;
    font-size: 32px;
  }

  @media (${mediaMaxWidth}) {
    display: block;
  }
`;

export const NavbarContents = styled.div`
  display: flex;
  max-width: calc(100% - ${logoWidth});
  flex-basis: auto;
  flex-grow: 1;
  align-items: center;
  gap: 5px;
  background: ${({ theme }) => theme.oldThemeHeader.background};
  padding-left: 8px;
  padding-right: 8px;
  z-index: 9;
  @media (${mediaMaxWidth}) {
    display: none;
  }
`;

export const DropdownContent = styled.div`
  display: none;
  flex-direction: column;
  gap: 5px;
  position: absolute;
  top: 55px;
  width: 100%;
  padding-left: 5px;
  padding-bottom: 5px;
  background: ${({ theme }) => theme.oldThemeHeader.background};
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.8);
  max-height: calc(100vh - 55px);
  overflow-y: auto;
  @media (${mediaMaxWidth}) {
    display: flex;
  }
`;

export const HeaderContentRow = styled.div`
  margin: 0px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 5px;
`;

export const HeaderLink = styled.a`
  display: block;
  color: ${({ theme }) => theme.oldThemeHeader.link.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;

  &:link {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.oldThemeHeader.link.colorHover};
  }
  &:active {
    text-decoration: none;
  }

  @media (${mediaMinWidth}) {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;

export const LinkSpacer = styled.span`
  margin-right: auto;
  @media (${mediaMaxWidth}) {
    display: none;
  }
`;

export const UserDetailsContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  @media (${mediaMaxWidth}) {
    flex-direction: row-reverse;
  }
`;

export const UserNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
`;

export const UserName = styled.h4`
  font-size: 16px;
  display: block;
  margin: 0px;
  color: ${({ theme }) => theme.oldThemeHeader.link.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;
  @media (${mediaMinWidth}) {
    text-align: right;
  }
`;

export const UserCompanyName = styled.h6`
  font-size: 12px;
  display: block;
  margin: 0px;
  color: ${({ theme }) => theme.oldThemeHeader.link.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;
  @media (${mediaMinWidth}) {
    text-align: right;
  }
`;

export const UserProfileImage = styled.img`
  border-radius: 50%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
  width: 35px;
  height: 35px;
  vertical-align: top;
  margin: 6px 0px;
`;

export const UserTestsLeftSpan = styled.span`
  padding: 0px 5px;
  background: ${colors.white};
  color: ${colors.black};
  border-radius: 2px;
  font-weight: bold;
  font-size: 11px;
  line-height: 19px;
  cursor: pointer;
`;
